/**
 * This set contains error codes that are present in the frontend but not in the backend or are deprecated
 */
const DEPRECATED_CODE = [
  '1522006',
  '1522007',
  '1522013',
  '1522109',
  '1522900',
  '1522901',
  '1522902',
  '1523204',
  '1523205',
  '1610011',
  '1610012',
  '1610013',
  '1610014',
  '1610015',
  '1610016',
  '1610017',
  '1610018',
];

/**
 * This object holds error codes ignored by the interceptor
 */
export const AccessErrorCode = {
  DEPRECATED_CODE,
  // Case View
  VIEW_NOT_EXISTS: ['1522200'],

  // Case Properties
  SPECIAL_TIP_ERRORS: ['1523007', '1523008', '1523009', '1523010', '1523011', '1523012'],

  // Field Add/Edit
  DEPENDENT_FIELD_UPLOAD_ERRORS: ['1522901', '1522902', '1522903'],

  // Automation Add/Edit
  AUTOMATION_INVALID_ERROR: ['1612011', '1612012', '1612013', '1612014', '1612100', '1613004'],

  // TrashList
  CASE_NOT_EXITS_THIS_VIEW: ['1523014', '1523015'],

  // Webform configure
  WEBFORM_URL_LINK_INVALID: ['1523707'],

  // View group is deleted
  VIEW_GROUP_NOT_EXISTS: ['1522206'],

  CASE_IS_UNAVAILABLE: ['1523000', '1523021'],
};

export const WarningCodes = ['1523022', '1523023', '1523024', '1523026', '1523028', '1523029', '1523030', '1523031'];

/**
 * This object stores the error code that the interceptor will intercept
 */
export const ErrorCode = {};
